import { apiGet, apiPost } from './api';

// ==================== 类型定义 ====================

export interface OperationLogItem {
  id: number;
  userId: number | null;
  username: string;
  userName: string;
  loginType: string;
  operation: string;
  method: string;
  params: string;
  requestUrl: string;
  requestMethod: string;
  responseCode: number | null;
  status: number;
  errorMsg: string;
  executionTime: number;
  ip: string;
  createTime: string;
}

export interface OperationLogPage {
  list: OperationLogItem[];
  total: number;
  page: number;
  pageSize: number;
}

// ==================== API 方法 ====================

/**
 * 分页查询操作日志
 */
export async function getOperationLogs(params: {
  page?: number;
  pageSize?: number;
  username?: string;
  operation?: string;
  status?: number | null;
  startTime?: string;
  endTime?: string;
}): Promise<OperationLogPage> {
  const query = new URLSearchParams();
  if (params.page) query.set('page', String(params.page));
  if (params.pageSize) query.set('pageSize', String(params.pageSize));
  if (params.username) query.set('username', params.username);
  if (params.operation) query.set('operation', params.operation);
  if (params.status !== undefined && params.status !== null) query.set('status', String(params.status));
  if (params.startTime) query.set('startTime', params.startTime);
  if (params.endTime) query.set('endTime', params.endTime);

  const res = await apiGet<{ code: number; data: OperationLogPage; msg?: string }>(
    `/api/operation-logs/list?${query.toString()}`
  );
  if (res.code !== 0) throw new Error(res.msg || '查询操作日志失败');
  return res.data;
}

/**
 * 查询日志详情
 */
export async function getOperationLogDetail(id: number): Promise<OperationLogItem> {
  const res = await apiGet<{ code: number; data: OperationLogItem; msg?: string }>(
    `/api/operation-logs/detail/${id}`
  );
  if (res.code !== 0) throw new Error(res.msg || '查询日志详情失败');
  return res.data;
}

/**
 * 清理旧日志
 */
export async function cleanOperationLogs(days: number): Promise<{ deleted: number }> {
  const res = await apiPost<{ code: number; data: { deleted: number }; msg?: string }>(
    '/api/operation-logs/clean',
    { days }
  );
  if (res.code !== 0) throw new Error(res.msg || '清理日志失败');
  return res.data;
}
